export const contactForm = {
  action: "https://api.web3forms.com/submit",
  accessKey:
    import.meta.env.VITE_WEB3FORMS_ACCESS_KEY ??
    "926d3ac0-95c9-4a79-9ccd-33da9b3ff275",
};
